import {Flag} from 'platform/components';
import {HStack, Show} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {type CustomerInquiryResponseBody} from '@dms/api/workshop';

import {type Nullish, type RequiredTestIdProps, suffixTestId} from 'shared/web';

import {useRequestSpecification} from '../hooks/useRequestSpecification';

interface RequestSpecificationProps extends RequiredTestIdProps {
  customerInquiry: CustomerInquiryResponseBody | Nullish;
}

export function RequestSpecification(props: RequestSpecificationProps) {
  const requestSpecification = useRequestSpecification(props.customerInquiry);

  return (
    <HStack spacing={2} wrap>
      <Show when={isNotNil(requestSpecification.vehicleType)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.vehicleType ?? ''}
          data-testid={suffixTestId('requestSpecification-vehicleType', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.make)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.make ?? ''}
          data-testid={suffixTestId('requestSpecification-make', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.modelFamily)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.modelFamily ?? ''}
          data-testid={suffixTestId('requestSpecification-modelFamily', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.trim)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.trim ?? ''}
          data-testid={suffixTestId('requestSpecification-trim', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.variant)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.variant ?? ''}
          data-testid={suffixTestId('requestSpecification-variant', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.licensePlate)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.licensePlate ?? ''}
          data-testid={suffixTestId('requestSpecification-licensePlate', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.vin)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.vin ?? ''}
          data-testid={suffixTestId('requestSpecification-vin', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.firstRegistration)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.firstRegistration ?? ''}
          data-testid={suffixTestId('requestSpecification-firstRegistration', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.production)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.production ?? ''}
          data-testid={suffixTestId('requestSpecification-production', props)}
        />
      </Show>
      <Show when={isNotNil(requestSpecification.currentMileage)}>
        <Flag
          colorScheme="blue"
          label={requestSpecification.currentMileage ?? ''}
          data-testid={suffixTestId('requestSpecification-currentMileage', props)}
        />
      </Show>
    </HStack>
  );
}
